import { useState } from "react";
import { Main, Content } from "../../components/Layout";
import { PrintPage } from "../../components/PrintPage";
import { Col, Row } from "react-bootstrap";
import DatePicker from "../../components/DatePicker";
import Slct from "../../components/Slct";

export default function Reports() {
  const reports = [
    {
      label: "Atendimento",
      parameters: [
        {
          label: "Status",
          value: "attendance_period",
        },
        {
          label: "Avaliações",
          value: "avaliation_period",
        },
      ],
      filters: [
        {
          label: "Atendente",
        },
      ],
    },
    {
      label: "Comercial",
    },
    { label: "Eventos" },
    { label: "Financeiro" },
    { label: "Formandos" },
    { label: "Itens Adicionais" },
    { label: "Operacional" },
    { label: "Tarefas" },
    { label: "Turmas" },
  ];

  const filter_init = {};
  const [filter, setfilter] = useState(filter_init);

  return (
    <PrintPage has_logo={true} signed_by={"Usuário Exemplo"}>
      <Main>
        <Content>
          <Row>
            <Col sm={2}>
              <span>Data Inicial</span>
              <DatePicker
                selected={filter?.date_start || ""}
                changeDate={__ev => {
                  setfilter({
                    ...filter,
                    date_start: __ev,
                    ...(__ev > filter?.date_end ? { date_end: null } : {}),
                  });
                }}
              />
            </Col>
            <Col sm={2}>
              <span>Data Final</span>
              <DatePicker
                selected={filter?.date_end || ""}
                changeDate={__ev => {
                  setfilter({
                    ...filter,
                    date_end: __ev,
                  });
                }}
                minDate={filter?.date_start || null}
              />
            </Col>
          </Row>
          {(() => {
            let _reports_list = reports?.map(__report => ({ value: __report.label, label: __report.label })) || [];
            let _report = reports?.find(__report => __report.label === filter?.report) || null;

            return (
              <>
                <Row className="mt-2">
                  <Col sm={2}>
                    <span>Relatório</span>
                    <Slct
                      options={_reports_list || []}
                      value={filter?.report}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          report: __ev.value,
                          parameter: null,
                        });
                      }}
                      placeholder="..."
                    />
                  </Col>
                  <Col sm={2}>
                    <span>Parâmetro</span>
                    <Slct
                      options={_report?.parameters || []}
                      value={filter?.parameter}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          parameter: __ev.value,
                        });
                      }}
                      placeholder="..."
                    />
                  </Col>
                  <Col sm={2}>
                    <span>Ordernar por</span>
                    <input type="text" placeholder="..." />
                  </Col>
                  <Col sm={2}>
                    <span>Tipo de Gráfico</span>
                    <input type="text" placeholder="..." />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col>
                    <span>[Filtros Adicionais dependendo do Relatório e Parâmetro]</span>
                    <div className="d-flex">
                      <input type="text" placeholder="..." className="" />
                      <input type="text" placeholder="..." className="ml-3" />
                      <input type="text" placeholder="..." className="ml-3" />
                      <input type="text" placeholder="..." className="ml-3" />
                      <input type="text" placeholder="..." className="ml-3" />
                    </div>
                  </Col>
                </Row>
              </>
            );
          })()}
        </Content>
      </Main>
    </PrintPage>
  );
}
